import { ActivatedRoute } from '@angular/router';
import { Itinerary } from './../itineray.model';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-itinerary-settings',
  templateUrl: './itinerary-settings.component.html',
  styleUrls: ['./itinerary-settings.component.css']
})
export class ItinerarySettingsComponent implements OnInit {

  constructor(private route: ActivatedRoute) { }

  itinerary: Itinerary;

  async ngOnInit() {
    this.itinerary = this.route.parent.snapshot.data.itinerary;
  }

}
